export const CNUM_PLACEHOLDER = '%CNUM%';

export const getCustomerUrl = (cNum: string, pattern: string) => {
    return pattern.replace(CNUM_PLACEHOLDER, cNum);
};
